/** Partner corpus — single source for Home strip and Partners page (M03). */
export const partners = [
  {
    id: 'utk',
    name: 'University of Tennessee',
    logo: '/utklogo_centered.png',
    website: 'https://cehhs.utk.edu/',
    description:
      'Supporting our research and educational initiatives through their College of Education, Health and Human Sciences.',
  },
  {
    id: 'one-knox-sc',
    name: 'One Knoxville SC',
    logo: '/OneKnoxBadge.png',
    website: 'https://www.oneknoxsc.com/',
    description:
      'Bringing professional soccer culture to East Tennessee and supporting youth development programs.',
  },
  {
    id: 'one-knox-collective',
    name: 'One Knoxville Collective',
    logo: '/Collectivelogo.png',
    website: 'https://www.oneknoxsc.com/collective/',
    description:
      'Fostering community through soccer and supporting innovative youth programs like footyLab.',
  },
  {
    id: 'girls-inc',
    name: 'Girls Inc. of Tennessee Valley',
    logo: '/GirlsInc_TNV_logo.png',
    website: 'https://girlsinctnv.org/',
    description:
      'Empowering girls to be strong, smart, and bold through STEM education and sports.',
  },
  {
    id: 'etfs',
    name: 'East Tennessee Freedom Schools',
    logo: '/ETSF_logo.png',
    website: 'https://www.easttnfreedomschools.com/',
    description:
      'Providing literacy-based summer programs that integrate STEM learning through footyLab.',
  },
  {
    id: 'kjds',
    name: 'Knoxville Jewish Day School',
    logo: '/kjds.png',
    website: 'https://www.kjds.org/',
    description:
      'Integrating innovative STEM education into their curriculum through footyLab programs.',
  },
  {
    id: 'tates',
    name: "Tate's School",
    logo: '/tates_logo.png',
    website: 'https://www.tatesschool.com/',
    description:
      'Pioneering afterschool STEM programs that combine technology with physical activity.',
  },
  {
    id: 'bgctnv',
    name: 'Boys & Girls Club of Tennessee Valley',
    logo: '/bgctnv_logo.png',
    website: 'https://bgctnv.org/',
    description:
      'Reaching youth across the region with innovative programs that inspire futures in STEM.',
  },
  {
    id: 'twelve',
    name: 'Twelve',
    logo: '/twelve_logo.png',
    website: 'https://twelve.football/',
    description:
      'Building AI that sees the game the way people who love it do — DataRook joined the Twelve Creator Collective, bringing professional-grade match analysis into youth STEM education.',
  },
  {
    id: 'ujima',
    name: 'Ujima',
    logo: '/ujima_logo.png',
    website: 'https://ujimasoccer.org/',
    description:
      'A holistic youth development program rooted in collective work and responsibility, using soccer to build community, develop leaders, and equip students for success on and off the field.',
  },
];

/** Curated Home logo strip (WD-04). */
export const homePartnerIds = [
  'utk',
  'one-knox-sc',
  'bgctnv',
  'tates',
  'etfs',
];

export const getPartnersByIds = (ids) =>
  ids.map((id) => partners.find((item) => item.id === id)).filter(Boolean);
